<template>
  <v-card class="ml-3 py-1 px-2 timebox shadow half-radius" :class="{ blinking: recording }">
    <slot>{{ time }}</slot>
  </v-card>
</template>
<script>
export default {
  props: {
    recording: Boolean,
    time: Number,
  },
};
</script>
<style scoped>
.timebox {
  font-size: 18px;
  background: #262626;
  color: white;
}
</style>
